import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import { store } from './app/store'
import { Provider } from 'react-redux'
import "./App.css";
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

// Global Components
import PersistGate from './components/persistGate';
import Layout from './components/layout';

// Landing and General Pages
import LandingPage from './screen/landing/landingPage';
import ContactUsPage from './screen/contactUs/contactUsPage';
import AboutUsPage from './screen/aboutUs/aboutUsPage';
import PricingPage from './screen/pricing/pricingPage';
import ComparisonPage from './screen/pricing/comparisonPage';
import Dashboard from './screen/dashboard/dashboard';

// Auth Pages
import LoginPage from './screen/login_register_forgetPassword/login';
import RegisterPage from './screen/login_register_forgetPassword/register';
import VerifyPage from './screen/login_register_forgetPassword/verify';
import ForgotPasswordPage from './screen/login_register_forgetPassword/forgotPasswordPage';
import VerifyResetPage from './screen/login_register_forgetPassword/verifyResetPage';
import ResetPasswordPage from './screen/login_register_forgetPassword/resetPasswordPage';

// User Profile Pages
import ProfilePage from './screen/userProfile/profilePage';
import EditProfilePage from './screen/userProfile/editProfilePage';

// Manage Subscription Pages
import SubscriptionSearchPage from './screen/subscription/subscriptionSearchPage';
import SubscriptionDetailPage from './screen/subscription/subscriptionDetailPage';
import SubscriptionUpgradePage from './screen/subscription/subscriptionUpgradePage';

// Manage Players Page
import ManagePlayersPage from './screen/playerManagement/managePlayersPage';

// Manage Holidays Page
import HolidaysAdmin from './screen/holidays/holidaysAdmin';

// Admin Manage Activities Page
import ManageActivitiesPage from './screen/activities/manageActivitiesPage';
import ActivityDetailPage from './screen/activities/activityDetailPage';
import ActivityForm from './screen/activities/activityForm';

// Coach Activities Pages
import CoachActivitiesPage from './screen/coachActivities/coachActivitiesPage';
import CoachActivityForm from './screen/coachActivities/coachActivityForm';
import CoachActivityDetailPage from './screen/coachActivities/coachActivityDetailPage';

// Other Coaches Activities Pages
import OtherCoachesListPage from './screen/otherCoachesActivities/otherCoachesList';
import OtherCoachesActivitiesList from './screen/otherCoachesActivities/otherCoachesActivitiesList';

// Player View Activities Page
import PlayerActivitiesPage from './screen/playerActivities/playerActivitiesPage';

// Coach Leaves Pages
import CoachLeavesPage from './screen/coachLeave/coachLeavesListing';
import CoachLeaveForm from './screen/coachLeave/coachLeaveForm';
import ManageCoachLeaveReasonsPage from './screen/coachLeave/coachLeaveReasonsPage';

// Attendance Pages
import AdminAttendance from './screen/attendance/adminAttendance';
import AttendanceHistory from './screen/attendance/attendanceHistory';
import MonthlyAttendanceSummary from './screen/attendance/monthlyAttendanceSummary';
import PlayerAttendance from './screen/attendance/playerAttendance';
import PlayerApplyLeave from './screen/attendance/playerApplyLeave';
import PlayerLeavesPage from './screen/attendance/playerLeavesPage';
import AttendLanding from './screen/attendance/attendLanding';
import PlayerLeaveList from './screen/attendance/playerLeaveList';

// Performance Review Pages
import AdminPerformanceReviewLanding from './screen/performanceReview/adminPerformanceReviewLanding';
import AddResultPage from './screen/performanceReview/addResultPage';
import AddAJSSRankingPage from './screen/performanceReview/addAJSSRankingPage';
import TeamReportPage from './screen/performanceReview/teamReportPage';
import IndividualProfilesPage from './screen/performanceReview/individualProfilesPage';
import PerformanceReview from './screen/performanceReview/performanceReview';

// 1 to 1 Training Logs Pages
import AdminPTLogsPage from './screen/ptLog/adminPTLogsPage';
import ManageGuidelinesPage from './screen/ptLog/manageGuidelinesPage';
import PTLogsPage from './screen/ptLog/ptLogsPage';
import AddNewPTLog from './screen/ptLog/addNewPTLog';
import ViewPTLog from './screen/ptLog/viewPTLog';
import EditPTLog from './screen/ptLog/editPTLog';
import PendingReviewPTLogPage from './screen/ptLog/pendingReviewPTLogPage';

// Coming Soon Page
import ComingSoon from './screen/comingSoon/comingSoonPage';

// Page Not Found Page
import PageNotFoundScreen from './screen/pageNotFound/pageNotFoundScreen';

const App = () => {

  return (
    <Provider store={store}>
      <PersistGate />
      <Router>
        <Routes>
          <Route element={<Layout />}>
            <Route path="/" element={<LandingPage />} />
            <Route path="/contact" element={<ContactUsPage />} />
            <Route path="/about-us" element={<AboutUsPage />} />
            <Route path="/pricing" element={<PricingPage />} />
            <Route path="/pricing/compare" element={<ComparisonPage />} />
            <Route path="/dashboard" element={<Dashboard />} />

            {/* Auth Pages */}
            <Route path="/login" element={<LoginPage />} />
            <Route path="/register" element={<RegisterPage />} />
            <Route path="/verify" element={<VerifyPage />} />
            <Route path="/forgot-password" element={<ForgotPasswordPage />} />
            <Route path="/verify-reset" element={<VerifyResetPage />} />
            <Route path="/reset-password" element={<ResetPasswordPage />} />

            {/* User Profile Pages */}
            <Route path="/profile" element={<ProfilePage />} />
            <Route path="/edit-profile" element={<EditProfilePage />} />

            {/* Manage Subscription Pages */}
            <Route path="/subscription" element={<SubscriptionSearchPage />} />
            <Route path="/subscription/:userId" element={<SubscriptionDetailPage />} />
            <Route path="/subscription/:userId/upgrade" element={<SubscriptionUpgradePage />} />

            {/* Manage Players Page */}
            <Route path="/manage-players" element={<ManagePlayersPage />} />

            {/* Manage Holidays Page */}
            <Route path="/manage-holidays" element={<HolidaysAdmin />} />

            {/* Admin Manage Activities Pages */}
            <Route path="/manage-activities" element={<ManageActivitiesPage />} />
            <Route path="/activities/:id" element={<ActivityDetailPage />} />
            <Route path="/activities/new" element={<ActivityForm isEdit={false} />} />
            <Route path="/activities/edit/:id" element={<ActivityForm isEdit={true} />} />

            {/* Coach Activities Pages */}
            <Route path="/coach-activities" element={<CoachActivitiesPage />} />
            <Route path="/coach-activities/:id" element={<CoachActivityDetailPage />} />
            <Route path="/coach-activities/new" element={<CoachActivityForm isEdit={false} />} />
            <Route path="/coach-activities/edit/:id" element={<CoachActivityForm isEdit={true} />} />

            {/* Other Coaches Activities Pages */}
            <Route path="/other-coaches-list" element={<OtherCoachesListPage />} />
            <Route path="/other-coaches-activities-list/:id" element={<OtherCoachesActivitiesList />} />

            {/* Player View Activities Page */}
            <Route path="/player-activities" element={<PlayerActivitiesPage />} />

            {/* 1 to 1 Training Pages */}
            <Route path="/pt-logs-list" element={<PTLogsPage mode="player" />} />
            <Route path="/pt-logs-list/:playerId" element={<PTLogsPage mode="coach" />} />
            <Route path="/pt-logs-player-list" element={<AdminPTLogsPage />} />
            <Route path="/manage-guidelines" element={<ManageGuidelinesPage />} />
            <Route path="/add-pt-log" element={<AddNewPTLog />} />
            <Route path="/view-pt-log/:id" element={<ViewPTLog mode="player" />} />
            <Route path="/view-pt-log/:playerId/:id" element={<ViewPTLog mode="coach" />} />
            <Route path="/edit-pt-log/:id" element={<EditPTLog />} />
            <Route path="/pending-review-pt-log" element={<PendingReviewPTLogPage />} />

            {/* Coach Leaves Pages */}
            <Route path="/coach-leaves-list" element={<CoachLeavesPage />} />
            <Route path="/coach-leaves/new" element={<CoachLeaveForm isEdit={false} />} />
            <Route path="/coach-leaves/edit/:id" element={<CoachLeaveForm isEdit={true} />} />
            <Route path="/manage-coach-leaves-reason" element={<ManageCoachLeaveReasonsPage />} />

            {/* Attendance Pages */}
            <Route path="/admin-attendance" element={<AdminAttendance />} />
            <Route path="/attendance-history" element={<AttendanceHistory />} />
            <Route path="/player-attendance" element={<PlayerAttendance />} />
            <Route path="/my-leaves" element={<PlayerLeavesPage />} />
            <Route path="/player-apply-leave" element={<PlayerApplyLeave />} />
            <Route path="/attend" element={<AttendLanding />} />
            <Route path="/player-leave-list" element={<PlayerLeaveList />} />
            <Route path="/monthly-attendance-summary" element={<MonthlyAttendanceSummary />} />

            {/* Performance Review Pages */}
            <Route path="/admin-performance-review-landing" element={<AdminPerformanceReviewLanding />} />
            <Route path="/add-result" element={<AddResultPage />} />
            <Route path="/add-ajss-ranking" element={<AddAJSSRankingPage />} />
            <Route path="/team-report" element={<TeamReportPage />} />
            <Route path="/individual-profiles" element={<IndividualProfilesPage />} />
            <Route path="/performance-review/:playerId" element={<PerformanceReview />} />

            {/* Coming Soon Page */}
            <Route path="/coming-soon" element={<ComingSoon title="Upcoming Feature" />} />

            {/* Page Not Found Page */}
            <Route path="*" element={<PageNotFoundScreen />} />
          </Route>
        </Routes>
        
      <ToastContainer position="top-center" autoClose={1000} />
      </Router>
    </Provider>
  );
};

export default App;